import React from "react";
import { Box, Typography, Grid, useTheme, useMediaQuery } from "@mui/material";
import { Images } from "../../../utils/Images";

const MedicalFundraisingCategories = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 959px)");
  const isDesktop = useMediaQuery("(min-width: 960px)");

  const categories = [
    {
      id: 1,
      icon: Images.heartOrgan,
      title: "Open Heart Surgery",
    },
    {
      id: 2,
      icon: Images.kidney,
      title: "Kidney Transplant",
    },
    {
      id: 3,
      icon: Images.newborn,
      title: "NICU Care",
    },
    {
      id: 4,
      icon: Images.bones,
      title: "Bone Marrow Transplant",
    },
    {
      id: 5,
      icon: Images.cancerRibbon,
      title: "Cancer Treatment",
    },
    {
      id: 6,
      icon: Images.question,
      title: "Any Other Disease?",
    },
  ];

  // Mobile: 2 per row, fixed size. Tablet/Desktop: keep flexible.
  const getCardStyles = () => {
    if (isMobile) {
      return {
        width: "157px",
        height: "107px",
        padding: "16px",
        borderRadius: "12px",
        border: "0.5px solid #E8E8E8",
        iconSize: "38px",
        gap: "14px",
      };
    } else if (isTablet) {
      return {
        width: "100%",
        height: "145px",
        paddingTop: "20px",
        paddingRight: "25px",
        paddingBottom: "20px",
        paddingLeft: "25px",
        borderRadius: "20px",
        border: "1px solid #E8E8E8",
        iconSize: "56px",
      };
    } else {
      return {
        width: "389px",
        height: "145px",
        paddingTop: "20px",
        paddingRight: "25px",
        paddingBottom: "20px",
        paddingLeft: "25px",
        borderRadius: "20px",
        border: "1px solid #E8E8E8",
        iconSize: "56px",
      };
    }
  };

  const cardStyles = getCardStyles();

  return (
    <Box
      sx={{
        width: "94.44%",
        maxWidth: "1440px",
        margin: "0 auto",
        marginTop: isMobile ? "30px" : "60px",
        marginBottom: isMobile ? "30px" : "60px",
      }}
    >
      {/* Header Section */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", mb: isMobile ? "10px" : "14px" }}>
        <Box
          sx={{
            width: isMobile ? "6px" : "8px",
            height: isMobile ? "6px" : "8px",
            borderRadius: "50%",
            backgroundColor: "#A9C74E",
          }}
        />
        <Typography
          sx={{
            fontFamily: "Arial",
            fontWeight: 400,
            fontSize: isMobile ? "10px" : "14px",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#131313",
          }}
        >
          MEDICAL FUNDRAISING CATEGORIES
        </Typography>
      </Box>

      {/* Title */}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: isMobile ? "22px" : isTablet ? "32px" : "36px",
          lineHeight: isMobile ? "30px" : "44px",
          color: "#1D1D1B",
          mb: isMobile ? "20px" : "40px",
          textAlign: "center",
        }}
      >
        What Medical Treatments Can You Raise Funds For?
      </Typography>

      {/* Cards Grid - 2 per row on mobile, equal size (157×107, gap 14px) */}
      <Grid
        container
        spacing={isMobile ? 1.75 : 2.75}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {categories.map((category) => (
          <Grid
            item
            key={category.id}
            xs={6}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: cardStyles.width,
                height: cardStyles.height,
                ...(isMobile
                  ? {
                      padding: "13x",
                      borderRadius: "12px",
                      border: "0.5px solid #E8E8E8",
                    }
                  : {
                      paddingTop: cardStyles.paddingTop,
                      paddingRight: cardStyles.paddingRight,
                      paddingBottom: cardStyles.paddingBottom,
                      paddingLeft: cardStyles.paddingLeft,
                      borderRadius: "20px",
                      border: "1px solid #E8E8E8",
                    }),
                backgroundColor: "#FFFFFF",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: isMobile ? 0 : "20px",
                boxShadow: "0px 10px 26px 0px #0000000A",
                transition: "all 0.3s ease",
              }}
            >
              {/* Icon */}
              <Box
                component="img"
                src={category.icon}
                alt={category.title}
                sx={{
                  width: cardStyles.iconSize ?? "56px",
                  height: cardStyles.iconSize ?? "56px",
                  objectFit: "contain",
                  flexShrink: 0,
                }}
              />

              {/* Title */}
              <Typography
                sx={{
                  // fontFamily: "Red Hat Display, sans-serif",
                  fontWeight: 600,
                  fontStyle: "normal",
                  fontSize: isMobile ? "12px" : "20px",
                  lineHeight: isMobile ? "22.65px" : "34px",
                  letterSpacing: isMobile ? "-0.02em" : "0%",
                  textAlign: "center",
                  verticalAlign: "middle",
                  color: "#1D1D1B",
                  marginTop: isMobile ? "14px" : 0,
                }}
              >
                {category.title}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MedicalFundraisingCategories;

